import React, { memo, useEffect, useState } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

interface IProps {
  data: {
    comfortModelYearId: number;
    comfortModelYearName: string;
    performanceModelYearId: number;
    performanceModelYearName: string;
    spaceModelYearId: number;
    spaceModelYearName: string;
    safeEquipModelYearId: number;
    safeEquipModelYearName: string;
  };
  active: any;
  setActive: any;
}
const NavList: React.FC<IProps> = ({ data, active, setActive }) => {
  const [navList, setNavList] = useState<{ title: string; value: number }[]>([]);

  // 性能实测 - 英雄榜排行
  useEffect(() => {
    if (!data) return;
    const newList: any = [];
    !!data?.safeEquipModelYearId && newList.push({ title: "安全", value: data.safeEquipModelYearId });
    !!data?.spaceModelYearId && newList.push({ title: "空間", value: data.spaceModelYearId });
    !!data?.comfortModelYearId && newList.push({ title: "舒適", value: data.comfortModelYearId });
    !!data?.performanceModelYearId && newList.push({ title: "性能", value: data.performanceModelYearId });
    setNavList(newList);
    !!newList.length && setActive(newList[0].title);
  }, [data]);

  if (!navList.length)
    return (
      <SkeletonTheme baseColor='#adcdff,'>
        <Skeleton className='w-full h-30' count={1} enableAnimation={false} />
      </SkeletonTheme>
    );

  return (
    <>
      {navList.map((item, index) => (
        <p
          key={index}
          style={{
            background: `${active === item.title ? "linear-gradient(180deg,#adcdff, #ffffff)" : ""}`,
          }}
          className={`text-14 w-[63px] h-30 rounded-tl-4 rounded-tr-4 flex justify-center items-center cursor-pointer ${
            active === item.title ? "border-none text-[#333]" : "border-1 border-solid border-[#E8E8E8] text-[#666]"
          }`}
          onClick={() => setActive(item.title)}
        >
          {item.title}
        </p>
      ))}
    </>
  );
};

export default memo(NavList);
